import { Injectable, Inject  } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Http, Response } from '@angular/http';
import { IMenu, IUrl } from './nav.model';
import { APP_CONFIG, AppConfig } from '../../config/app.config.module';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ArticleService } from '../../article/article.service';
import { AnnouncementlistService } from '../../announcementlist/announcementlist.service';
import { BreadcrumbService } from '../../header/breadcrumb/breadcrumb.service';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { GalleryService } from '../../gallery/gallery.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ISubscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Provide service methods for Main Navigation Data.
 **/
@Injectable()
export class NavService {
  myMethod$: Observable<any>;
  articles: any[];
  galleries: any[];
  breadcrumb: any;
  isValid: any;
  lfcontent: boolean;
  topicStatus: any;
  loader:boolean = false;
  dataT: any;

  ispopUpShow: boolean = false;
  isNavSuggestionList: boolean = false;
  isHomeSearchSuggestionList: boolean = false;
  isSearchSuggestionList: boolean = false;
  isNavDropDown: boolean = false;
  
  private myMethodSubject = new Subject<any>();
  announces: any[];
  private subscriptionLang: ISubscription;
  private articleContent: ISubscription;

  lang: string;
  langId: number;
  loading:boolean = false;
  archives: any[];
  restricted = true;
  digitalTop = false;
  previous = null;
  public firtLogId: string;
  public firstLogFullName: string;
  public userName = new BehaviorSubject<any>('');
  public fullName = new BehaviorSubject<any>('');
  public passport = new BehaviorSubject<any>('');
  public email = new BehaviorSubject<any>('');
  public autoUserData = new BehaviorSubject<any>(null);
  public validMyIdentity = new BehaviorSubject<boolean>(false);
  
  private menuUrl: string = this.config.urlMenu;
  private articleUrl: string = this.config.urlArticle;
  private galleryUrl: string = this.config.urlGallery;
  private urlAnnouncement: string = this.config.urlAnnouncementSub;
  private subUrl: string = this.config.urlSubtopic;
  private popularUrl: string = this.config.urlPopularSearch;
  private highlightUrl: string = this.config.urlHighlights;
  private ePartCategoryUrl: string = this.config.urlEpartCategory;

  // tslint:disable-next-line:max-line-length
  constructor(private pageTitle: Title, private http: Http, @Inject(APP_CONFIG) private config: AppConfig, private translate: TranslateService, private route: ActivatedRoute, private router: Router, private breadcrumbService: BreadcrumbService, private galleryService: GalleryService, private articleService: ArticleService, private announceService: AnnouncementlistService) {
    //console.log('navservice constructor');
    this.topicStatus = true;
    this.myMethod$ = this.myMethodSubject.asObservable();

    this.lang = translate.currentLang;
    this.langId = 1; 
    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      //console.log('navservice onLangChange');
      const myLang = translate.currentLang;
    
      if (myLang == 'en') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.langId = 1;
        });

      }
      if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.langId = 2;
        });
      }

    });
  }

  generateTitle() {
    let title = 'MyGOV - ';
    let i=0;
    var breadcrum =this.articleService.articles.map((articles)=>{
        return articles.breadcrum;
    })

    for (let index=0; index < breadcrum.length; index++) {
     
      if (breadcrum[index]) {
        let bread = breadcrum[index];
          bread.forEach((item) => {
            if (i == 0) {
              title = title+item.breadcrumName;  
            } else {
              title = title+' | '+ item.breadcrumName;
            }
            i++;
          });
      } 
    }
    return title;    
  }

  escapeRegExp(string, unescape?) {

    if(unescape) {
      string.match(new RegExp('[%26]', 'g'), '&')
      .match(new RegExp('[%28]', 'g'), '(')
      .match(new RegExp('[%29]', 'g'), ')')
      .match(new RegExp('[%27]', 'g'), "'")
      .match(new RegExp('[%22]', 'g'), '"')
    } else {
      string.replace(/[&\\]/g, '%26')
      .replace(/[(\\]/g, '%28')
      .replace(/[)\\]/g, '%29')
      .replace(/['\\]/g, '%27')
      .replace(/["\\]/g, '%22');
    }
    // .replace(/[\\]/g, '')
    // .replace(/[\\]/g, '')
    // .replace(/[\\]/g, '')

    return string; 
}


  getMenuData(lang): Observable<IMenu[]> {
    return this.http.get(this.config.urlPortal + 'cp/menu?language=' + lang)
      .map((response: Response) => response.json().corePortalMenuList)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }


  getHotTopics(lang): Observable<IMenu[]> {

    return this.http.get(this.highlightUrl + '?language=' + lang)
      .map((response: Response) => response.json().list)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }



  getFAQData(lang): Observable<IMenu[]> {

    return this.http.get(this.config.urlFaq + '?language=' + lang)
      .map((response: Response) => response.json().faqList)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }


  getPopularData(body) {
    let dataUrl;
    let env = window.location.hostname;
    let envOrigin = window.location.origin;
    let localURL = envOrigin+'/gosg/';

    //

    if(env == 'localhost')
      dataUrl = this.popularUrl;
    else
      dataUrl = localURL+'popular';

    //

    return this.http.post(dataUrl, body)
      .map((response: Response) => response.json().data[0].term)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }


  getGalleryData(lang: string, ID?: number, keyword?: string, year?: string, month?: string, day?: string): Observable<boolean[]> {

    let getApi;

    if(ID) {
      if(ID == 5 && keyword)
        getApi = this.config.urlGallery + '?language=' + lang+ '&id=' +ID+'&agency='+keyword;
      else if (ID != 5 && (year || month || day))
      {
        if(ID != 5 && year){
          getApi = this.config.urlGallery + '?language=' + lang+ '&id=' +ID+'&year='+year;
        }
        if(ID != 5 && year && month){
          getApi = this.config.urlGallery + '?language=' + lang+ '&id=' +ID+'&year='+year+'&month='+month;
        }
        if(ID != 5 && year && month && day){
          getApi = this.config.urlGallery + '?language=' + lang+ '&id=' +ID+'&year='+year+'&month='+month+'&day='+day;
        }
      }        
      else
        getApi = this.config.urlGallery + '?language=' + lang+ '&id=' +ID;      
    } 
    else {
      getApi = this.config.urlGallery + '?language=' + lang;
    }

    // if (!isNaN(ID)) {

      return this.http.get(getApi)
        .take(1)
        .map((response: Response) => response.json())

        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    // }
  }


  getArticleData(moduleName, lang: string, ID: number, audit?): Observable<boolean[]> {
    console.log('test-'+ audit)
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
    if (!isNaN(ID)) {

      return this.http.get(this.config.urlPortal + moduleName + '/' +ID + '?language=' + lang+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)

        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }


  getRSSData(moduleName, lang: string, ID: number, audit?): Observable<boolean[]> {

    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }

    if (!isNaN(ID)) {

      return this.http.get(this.config.urlPortal + moduleName + '/' +ID + '?language=' + lang+isAudit)
        .take(1)
        .map((response: Response) => response.json().results)

        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }

  getArticleDataOther(moduleName, lang: string, ID: number, url, audit?): Observable<boolean[]> {
    console.log('getArticleDataOther');
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
    if (!isNaN(ID)) {

      return this.http.get(this.config.urlPortal + moduleName + '/' +ID + '?language=' + lang+'&type='+url+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)

        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }

  getSubArticleUrl(subID: number, lang, audit?) {
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
    if (!isNaN(subID)) {
      return this.http.get(this.config.urlPortal  + 'subcategory/'+subID + '?language=' + lang+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)
        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }

  getSubArticleUrlByAgency(lang, audit?) {
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }

      return this.http.get(this.config.urlPortal  + 'publication/agencies?language=' + lang+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)
        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );

  }



  getSubArticleUrlOthers(subID: number, lang, url, audit?) {
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
    if (!isNaN(subID)) {
      return this.http.get(this.config.urlPortal +'subcategory/'+subID + '?language=' + lang+'&type='+url+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)
        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }

  getContentUrl(subID: number, lang, audit?) {
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
    if (!isNaN(subID)) {
      return this.http.get(this.config.urlPortal  + 'content/'+subID + '?language=' + lang+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)
        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            this.loader = false;
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }

  getContentUrlOther(subID: number, lang, url, audit?) {
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
    if (!isNaN(subID)) {
      return this.http.get(this.config.urlPortal + 'content/' +subID + '?language=' + lang+'&type='+url+'&view=true'+isAudit)
        .take(1)
        .map((response: Response) => response.json().contentCategoryResource.results)
        // .catch((error:any) =>
        // Observable.throw(error.json().error || 'Server error')
        // );
        .catch(
        (err: Response, caught: Observable<any[]>) => {
          if (err !== undefined) {
            this.router.navigate(['/404']);
            return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
          }
          return Observable.throw(caught); // <-----
        }
        );
    }
  }


  getSubRss(moduleName, subID: number, lang, audit?) {
    let isAudit = '';
    if (audit=='stopaudit') {
      isAudit = '&audit=false';
    }
     if (!isNaN(subID)) {
       return this.http.get(this.config.urlPortal  + moduleName +'/id/'+ subID + '?language=' + lang+isAudit)
         .take(1)
         .map((response: Response) => response.json().results)
         // .catch((error:any) =>
         // Observable.throw(error.json().error || 'Server error')
         // );
         .catch(
         (err: Response, caught: Observable<any[]>) => {
           if (err !== undefined) {
             this.router.navigate(['/404']);
             return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
           }
           return Observable.throw(caught); // <-----
         }
         );
     }
   }

  triggerSubArticle(subID, lang, audit?) {
   
  // use setTimeout - prevent ExpressionChangedAfterItHasBeenCheckedError errors in development mode
   //setTimeout(()=>{
    this.loader = true;
   //}) 
  

    if (!isNaN(subID)) {
     this.articleService.articles = [''];
      this.articles = [''];
      return this.route.paramMap
        .switchMap((params: ParamMap) =>
          this.getSubArticleUrl(subID, lang, audit))
        .subscribe(resSliderData => {
          this.articleService.articles = resSliderData;
          this.articles = resSliderData;
          this.breadcrumb = this.breadcrumbService.getBreadcrumb();
          this.isValid = this.breadcrumbService.isValid = true;
          this.breadcrumb = this.breadcrumb.name = '';
          this.pageTitle.setTitle(this.generateTitle());
          this.loader = false;
        });
    }
  }

  triggerSubArticleOther(subID, lang, url, audit?) {
    this.loader = true;
    // alert("Trigger sub acrticle");
     if (!isNaN(subID)) {
       this.articleService.articles = [''];
       this.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getSubArticleUrlOthers(subID, lang, url, audit))
         .subscribe(resSliderData => {
           this.articleService.articles = resSliderData;
           this.articles = resSliderData;
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.pageTitle.setTitle(this.generateTitle());
           this.loader = false;

         });
     }
   }

   triggerSubArticleAgency(lang, audit?) {
      this.loader = true;
    // alert("Trigger sub acrticle");
       this.articleService.articles = [''];
       this.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getSubArticleUrlByAgency(lang, audit))
         .subscribe(resSliderData => {
           this.articleService.articles = resSliderData;
           this.articles = resSliderData;
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.pageTitle.setTitle(this.generateTitle());
           this.loader = false;

         });

   }

  triggerContent(subID, lang, audit?) {
    console.log('triggerContent');
    
    //setTimeout(()=>{
      this.loader = true;
    //});
   

     if (!isNaN(subID)) {
       this.articleService.articles = [''];
       this.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getContentUrl(subID, lang, audit))
         .subscribe(resSliderData => {
           //console.log('jjjjj');
           //console.log(resSliderData[0]);
           if (resSliderData[0] && !resSliderData[0].content) {
             console.log('Content Not Exist');
             let obj;
             if (this.langId == 1) {
              obj = { contentId: -1, contentText : '<h4>Content no longer exists.</h4>' };
              resSliderData[0].content = obj;
             } else {
              obj = { contentId: -1, contentText : '<h4>Kandungan sudah tidak wujud.<h4>' };
              resSliderData[0].content = obj;
             }
             //console.log(resSliderData);
           }
           this.articleService.articles = resSliderData;
           this.articles = resSliderData;
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.loader = false;
           this.pageTitle.setTitle(this.generateTitle());
         });
     }
   }

   
   triggerContentOther( subID, lang, url, audit?) {
    this.loader = true;
    // alert("Trigger sub acrticle");
     if (!isNaN(subID)) {
       this.articleService.articles = [''];
       this.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getContentUrlOther(subID, lang, url, audit))
         .subscribe(resSliderData => {
           this.articleService.articles = resSliderData;
           this.articles = resSliderData;
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.pageTitle.setTitle(this.generateTitle());
           this.loader = false;

         });
     }
   }


  triggerSubRss(topicID, subID, lang, audit?) {
    this.loader = true;
    // alert("Trigger sub acrticle");
     if (!isNaN(subID)) {
      this.articleService.articles = [''];
      this.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getSubRss(topicID, subID, lang, audit))
         .subscribe(resSliderData => {
           this.articleService.articles = resSliderData;
           this.articles = resSliderData;
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.pageTitle.setTitle(this.generateTitle());
           this.loader = false;
         });
     }
   }
   

   triggerArticle(moduleName, lang, topicID, audit?) {
    console.log('triggerArticle');
    this.loader = true;
    

     if (!isNaN(topicID)) {
       this.articles = [''];
       this.articleService.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getArticleData(moduleName, lang, topicID, audit))
         .subscribe(resSliderData => {
           this.articleService.articles = resSliderData;
           this.articleService.articleUpdated.emit('updated');
           this.articles = resSliderData;
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.pageTitle.setTitle(this.generateTitle());
           this.loader = false;
           //console.log(this.articles);
         });
     }
   }

   triggerEpartChange(moduleName, lang, topicID) {

    this.loader = true;


     if (!isNaN(topicID)) {
       this.articles = [''];
       this.articleService.articles = [''];
       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getArticleData(moduleName, lang, topicID))
         .subscribe(resSliderData => {
           this.articleService.articles = resSliderData;
           //sthis.articleService.articleUpdated.emit('updated');
           this.articles = resSliderData;
           //this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           //this.isValid = this.breadcrumbService.isValid = true;
           //this.breadcrumb = this.breadcrumb.name = '';
           //this.pageTitle.setTitle(this.generateTitle());
           this.loader = false;
         });
     }
   }

   triggerRSS(moduleName, lang, topicID, audit?) {
    // this.loader = true;
    if (!isNaN(topicID)) {
      this.articles = [''];
      this.articleService.articles = [''];
      return this.route.paramMap
        .switchMap((params: ParamMap) =>
          this.getRSSData(moduleName, lang, topicID, audit))
        .subscribe(resSliderData => {
          this.articleService.articles = resSliderData;
          this.articles = resSliderData;
          this.breadcrumb = this.breadcrumbService.getBreadcrumb();
          this.isValid = this.breadcrumbService.isValid = true;
          this.breadcrumb = this.breadcrumb.name = '';
          this.pageTitle.setTitle(this.generateTitle());
          this.loader = false;
        });
    }
  }

  generateTitleArchive() {
    let title = '';
    let i = 0;
    var breadcrum =this.articleService.archives.map((articles)=>{
        return articles.breadcrum;
    })
    //console.log(breadcrum);

    for (let index=0; index < breadcrum.length; index++) { 
      if (breadcrum[index]) {
        let bread = breadcrum[index];
        bread.forEach((item) => {
            if (i == 0) {
              title = title+item.breadcrumName;  
            } else {
              title = title+' | '+ item.breadcrumName;
            }
            i++;
        });
      } 
    }
    return title;    
  }


   triggerArticleOthers(moduleName, lang, topicID, url, audit?) {
    this.loader = true;
    if (!isNaN(topicID)) {
      this.archives = [''];
      this.articleService.archives = [''];
      return this.route.paramMap
        .switchMap((params: ParamMap) =>
          this.getArticleDataOther(moduleName, lang, topicID, url, audit))
        .subscribe(resSliderData => {
          this.articleService.archives = resSliderData;
          this.archives = resSliderData;
          this.breadcrumb = this.breadcrumbService.getBreadcrumb();
          this.isValid = this.breadcrumbService.isValid = true;
          this.breadcrumb = this.breadcrumb.name = '';
          let title = this.generateTitleArchive();
          if (title !== 'MyGOV - ') {
            this.pageTitle.setTitle(title);
          }
         
          this.loader = false;
        });
    }
  }

   triggerGalleries(lang, galleryID?, keyword?, year?, month?, day?) {

    let currYear = new Date().getFullYear();

    // this.loader = true;
    let newGallery:any = [];
    if(galleryID == 5 && !keyword)
      keyword = '';

    //  if (!isNaN(galleryID)) {
       this.galleries = [''];
       this.galleryService.galleries = [''];

       return this.route.paramMap
         .switchMap((params: ParamMap) =>
           this.getGalleryData(lang, galleryID, keyword, currYear.toString(), month, day))
         .subscribe(resGalleryData => {
           this.galleryService.galleries = resGalleryData;
           this.galleries = resGalleryData;

           this.galleries['leftMenu'].forEach(el => {
             if(el.id == 2) {
                if(lang == 1)
                  el.name = 'photos'
                else
                  el.name = 'foto'
             }
             if(el.id !== 1){
                newGallery.push(el);
             }
           });

           if(this.galleries['list']) {
             this.galleries['list'].forEach(el => {
               el.publishDate = moment(el.publishDate).format('DD-MM-YYYY');
            });
           }

           this.galleries['leftMenu'] = newGallery;
           
           for(let i = 0; i < this.galleries["leftMenu"].length; i++){
              if(this.galleries["leftMenu"][i].active == true){
                localStorage.setItem('idmenuleft',this.galleries["leftMenu"][i].id);
              }
           }
           this.breadcrumb = this.breadcrumbService.getBreadcrumb();
           this.isValid = this.breadcrumbService.isValid = true;
           this.breadcrumb = this.breadcrumb.name = '';
           this.loader = false;
         });
    //  }
   }

  getAnnouncement(moduleName, lang: number): Observable<boolean[]> {

    return this.http.get(this.urlAnnouncement + '?language=' + lang)
    .take(1)
    .map((response: Response) => response.json())
    .catch(
    (err: Response, caught: Observable<any[]>) => {
      if (err !== undefined) {
        this.router.navigate(['/404']);
        // tslint:disable-next-line:max-line-length
        return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
      }
      return Observable.throw(caught);
    });
  }

  getAnnouncementList(moduleName, lang: number, id1?: string): Observable<boolean[]> {
    if (id1) {
      return this.http.get(this.urlAnnouncement + '/id/' + id1 + '?language=' + lang)
      .take(1)
      .map((response: Response) => response.json())
      .catch(
      (err: Response, caught: Observable<any[]>) => {
        if (err !== undefined) {
          this.router.navigate(['/404']);
          // tslint:disable-next-line:max-line-length
          return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
        }
        return Observable.throw(caught);
      });
    }
  }

  triggerAnnouncementList(lang, id1) {
    // this.loader = true;
        if (lang === 'ms') {
            lang = 2;
        }
        if (lang === 'en') {
            lang = 1;
        }
        if (id1) {
          return this.route.paramMap
        .switchMap((params: ParamMap) =>
        this.getAnnouncementList('announcement', lang, id1))
        .subscribe(resAllAnnounce => {
            // this.announceRes = resAllAnnounce;
            //convert object to array
            // const temp1 = this.announceRes[0];
            // const temp = Object.keys(temp1).map(key => temp1[key]);
            // this.announces = temp;
            this.announceService.announces = resAllAnnounce;
            this.breadcrumb = this.breadcrumbService.getBreadcrumb();
            this.isValid = this.breadcrumbService.isValid = true;
            this.breadcrumb = this.breadcrumb.name = '';
            this.loader = false;
        });
        }
    }

    triggerAnnouncementDetails(moduleName, lang, id1, id2) {
      // this.loader = true;
        if (lang === 'ms') {
            lang = 2;
        }
        if (lang === 'en') {
            lang = 1;
        }
        return this.route.paramMap
        .switchMap((params: ParamMap) =>
        this.getAnnouncementDetails(moduleName, lang, id1, id2))
        .subscribe(resAllAnnounce => {
            this.announceService.announceDetails = resAllAnnounce;
            this.breadcrumb = this.breadcrumbService.getBreadcrumb();
            this.isValid = this.breadcrumbService.isValid = true;
            this.breadcrumb = this.breadcrumb.name = '';
            this.loader = true;
        });
    }

  getAnnouncementDetails(moduleName, lang: number, id1?: string, id2?: string): Observable<boolean[]> {
    return this.http.get(this.articleUrl + '/' + id1 + '/' + id2 + '?language=' + lang)
    .take(1)
    .map((response: Response) => response.json())
    .catch(
    (err: Response, caught: Observable<any[]>) => {
      if (err !== undefined) {
        this.router.navigate(['/404']);
        return Observable.throw('The Web server (running the Web site) is currently unable to handle the HTTP request due to a temporary overloading or maintenance of the server.');
      }
      return Observable.throw(caught);
    });
  }

  getEpartCategory(lang) {
    return this.http.get(this.ePartCategoryUrl+"?language="+lang)
    .take(1)
    .map((response: Response) => response.json())
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getPreviousSearch() {
    this.previous = localStorage.getItem('previous');
    return this.previous;
  }

  setPreviousSearch(str) {
    this.previous = str;
    localStorage.setItem('previous', this.previous);
  }

  deletePreviousSearch() {
    localStorage.removeItem('previous');
  }
}



// WEBPACK FOOTER //
// ./src/app/header/nav/nav.service.ts